import gql from 'graphql-tag'

export const popularSearch = gql`
  query PopularSearch($site: [String]) {
    globalSet(site: $site, handle: "navigationHighlight") {
      id
      ... on navigationHighlight_GlobalSet {
        ricerchePopolari
      }
    }
  }
`
